module.exports = __webpack_public_path__ + "img/badge.3a5d3328.svg";